import styles from './ProductSave.module.css'
import clsx from 'clsx'
import type { BasicStyledComponent, DSNCDealMSRP } from 'shared-definitions/types'
import { wrapWithCurrency, priceFormat } from 'shared-code/format'

interface ProductSaveProps extends BasicStyledComponent {
  msrp: DSNCDealMSRP
  currency: string
  discount: number
}

const ProductSave: React.VFC<ProductSaveProps> = ({ currency, discount, msrp, className }) => (
  <div className={clsx(styles.container, className)}>
    <div className={styles.msrp}>{'MSRP'}</div>
    <div className={styles.save}>{'SAVE'}</div>
    <div className={styles.price}>{wrapWithCurrency(priceFormat(msrp.price), msrp.currency)}</div>
    <div className={styles.discount}>{wrapWithCurrency(priceFormat(discount), currency)}</div>
  </div>
)

export default ProductSave
